module.exports = __webpack_public_path__ + "img/title-live-talk.69a45b5f.png";